import {FunctionComponent, useMemo} from 'react';
import {useCompareParams} from '../CompareContent';
import {CompareWithPartsResponse} from '../../../../../networking/repos/CompareRepository';
import University from '../../../../../networking/models/University';
import CompareTitle from '../../../partials/compare/CompareTitle';
import CompareTable, {fillParts, Part} from '../../../partials/compare/CompareTable';
import Breadcrumbs from '../../../../utils/Breadcrumbs';
import { compareColors } from '../../../../../config/theming';

interface Props {
    universities: University[];
    parts: CompareWithPartsResponse;
}

const CompareFacilitiesContent: FunctionComponent<Props> = (props) => {
    const [, idString] = useCompareParams();

    const parts = useMemo(() => {
        return props.parts.reduce((parts: Part[], current) => {
            return fillParts(parts, current.active_questions);
        }, []);
    }, [props.parts]);

    return (
        <>
            <CompareTitle colors={compareColors} universities={props.universities} />

            <Breadcrumbs
                breadcrumbs={
                    [
                        { name: "Home", url: "/" },
                        { name: "Universities", url: "/universities" },
                        { name: "Compare", url: `/compare/${idString}` },
                        { name: "Facilities", url: `/compare/${idString}/facilities` }
                    ]
                }
            />

            <div className={'compare-page__content'}>
                <h4 className={'compare-facilities-page__title'}>Facilities</h4>

                <div className={'compare-page__tables'}>
                    { parts.map((part, i) => (
                        <div className={'compare-page__table'} key={i}>
                            <CompareTable colors={compareColors} part={part} />
                        </div>
                    )) }
                </div>
            </div>
        </>
    );
};

export default CompareFacilitiesContent;
